// extracted by mini-css-extract-plugin
export default {"header":"styles_header__yL34T","buttons":"styles_buttons__1NqaZ"};